// extracted by mini-css-extract-plugin
module.exports = {"box":"homecatbar-module--box--Qxtv4","name":"homecatbar-module--name--17ZsI","bar":"homecatbar-module--bar--2NCe9"};